import { Component, OnInit } from '@angular/core';
import { ArticleService, PublicArticle } from '../services/article.service';

@Component({
  selector: 'app-blog-home',
  templateUrl: './blog-home.component.html',
  styleUrls: ['./blog-home.component.css']
})
export class BlogHomeComponent implements OnInit {
  articles: PublicArticle[] = [];
  loaded = false;

  constructor(public articleService: ArticleService) {}

  ngOnInit(): void {
    this.articleService.getPublished({ limit: 3 }).subscribe({
      next: (res) => {
        this.articles = res?.data ?? [];
        this.loaded = true;
      },
      // The section simply stays hidden if articles can't be loaded
      error: () => (this.loaded = true)
    });
  }

  trackById(_: number, article: PublicArticle): number {
    return article.id;
  }
}
